"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-6.18-2.116a.5.5 0 0 0-.64-.768l-3 2.5a.5.5 0 0 0 0 .768l3 2.5a.5.5 0 0 0 .64-.768L11.281 12z"
}), 'PreviousCircleFilled');
//# sourceMappingURL=index.js.map